import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {GlobalMaterial} from '../types'

export const GlobalMaterialsQueryKey = 'globalMaterials'

const globalMaterialsQueryOptions = () => ({
  queryKey: [GlobalMaterialsQueryKey] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<GlobalMaterial[]>(
      '/plants/materials/global-materials',
      {signal}
    )
    return response.data
  }
})

type Params<TReturn = GlobalMaterial[]> = {
  options?: Omit<UseQueryOptions<GlobalMaterial[], AxiosError, TReturn>, 'queryKey' | 'queryFn'>
}

export const useGlobalMaterials = <TReturn = GlobalMaterial[]>({options}: Params<TReturn> = {}) =>
  useQuery<GlobalMaterial[], AxiosError, TReturn>({
    ...globalMaterialsQueryOptions(),
    ...options
  })
